exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".price-num[data-v-487a6787]{width:350px}.price-num .num[data-v-487a6787]{width:100px;margin-top:15px;margin-right:15px;text-align:center;line-height:30px;font-size:12px;border:1px solid #eee;border-radius:2px;cursor:pointer}\n", ""]);

// exports
